import React from "react";
import ApplicationsHeading from "./components/ApplicationsHeading";
import CredentialBlock from "./components/CredentialBlock";
import CredentialProvider from "./context/CredentialContext";
import Header from "./components/Header";

export default function Applications({ workspace, locale }) {
  return (
    <CredentialProvider>
      <Header workspace={workspace} locale={locale} />
      <ApplicationsHeading workspace={workspace} />
      <CredentialBlock workspace={workspace} />
    </CredentialProvider>
  );
}
